const LibDialog = {
    show: (content, callback) => {
        if (document.querySelector(".lib--dialog > .part_dialog") !== null) {
            document.querySelector(".lib--dialog > .part_dialog").remove();
        }

        if (document.querySelector(".lib--dialog") === null) {
            document.body.insertAdjacentHTML("beforeend", `<div class="lib--dialog"></div>`);
        }

        document.querySelector(".lib--dialog").insertAdjacentHTML("beforeend", content);
        document.querySelector(".lib--dialog").style["display"] = "flex";

        document.body.classList.add("no-scroll");

        if (callback) {
            callback();
        }

        document.querySelector(".lib--dialog").addEventListener("mousedown", (e) => {
            if (e.target.classList.contains("lib--dialog")) {
                document.documentElement.addEventListener("mouseup", function e() {
                    LibDialog.hide();
                    document.documentElement.removeEventListener("mouseup", e);
                });
            }
        }, true);
    },
    hide: (callback) => {
        if (document.querySelector(".lib--dialog") !== null) {
            document.querySelector(".lib--dialog").classList.add("state--hiding");
        }

        setTimeout(function () {
            if (document.querySelector(".lib--dialog") !== null) {
                document.querySelector(".lib--dialog").style["display"] = "none";
                document.body.classList.remove("no-scroll");

                document.querySelector(".lib--dialog").remove();
            }

            if (callback) {
                callback();
            }
        }, 300);
    },
    action: (element, url, callback) => {
        fetch(url, {headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response) => {
            return response.text();
        })
        .then((data) => {
            let html = (new DOMParser().parseFromString(data, "text/html").body.children.body.querySelector(".part-dialog"));

            if(html !== null) {
                LibDialog.show(html.outerHTML, callback);
            }
        });
    }
};